import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TranslocoLocaleWrapperService } from 'app/fuse-template/core/transloco/translocoLocale.service';
import { clone } from 'lodash';

@Directive({
    selector: '[numericFormat]',
})
export class NumericFormatDirective {
    @Input() max: string = null;

    constructor(
        private model: NgControl,
        private translocoLocaleService: TranslocoLocaleWrapperService
    ) {}

    ngOnInit() {
        this.model.valueChanges.subscribe((value) => {
            if (value.length < 0) {
                this.model.valueAccessor?.writeValue(this.formatValue(value));
            }
        });
    }

    @HostListener('input', ['$event'])
    onInput(event: any) {
        const input = event.target as HTMLInputElement;
        let value = input.value;

        if (value.length == 0) {
            return value;
        }

        const initialLength = clone(value.length);
        const cursorPosition = event.target.selectionStart;

        input.value = this.formatValue(value);

        // Fix cursor position
        if (initialLength == input.value.length) {
            event.target.selectionEnd = cursorPosition;
        } else if (initialLength < input.value.length) {
            event.target.selectionEnd = input.value.length !== 1 && input.value.length % 4 == 1 ? cursorPosition + 1 : cursorPosition;
        } else if (initialLength > input.value.length) {
            event.target.selectionEnd = input.value.length !== 3 && input.value.length % 4 == 3 ? cursorPosition - 1 : cursorPosition;
        }
    }

    @HostListener('focusout', ['$event'])
    onBlur(event: any) {
        const input = event.target as HTMLInputElement;
        let value = input.value;

        if (value.length == 0) {
            return value;
        }

        // Formatting the value on focus out makes it so that trailing zeros after a decimal separator are removed on input element blur
        var numericValue = this.translocoLocaleService.parseLocalizedNumber(value);
        input.value = this.translocoLocaleService.localizeNumber(numericValue);
    }

    private formatValue = (value: string): string => {
        // Skip formatting numbers if the value string ends with a decimal separator or a zero after a decimal separator, allows inputting numbers with decimal places
        if (
            value.length > 1 &&
            (value.endsWith(this.translocoLocaleService.getNumberDecimalSeparator()) || value.endsWith('0')) &&
            (value.match(new RegExp(this.translocoLocaleService.getNumberDecimalSeparator().replace(/[.]/g, '\\$&'), 'g'))?.length ?? 0) ==
                1
        ) {
            return value;
        }

        var numericValue = this.translocoLocaleService.parseLocalizedNumber(value);
        var numericMaxValue = this.max ? this.translocoLocaleService.parseLocalizedNumber(this.max) : Number.POSITIVE_INFINITY;

        return this.translocoLocaleService.localizeNumber(numericValue > numericMaxValue ? numericMaxValue : numericValue);
    };
}
